import React from 'react'
import PropTypes from 'prop-types'
import { Input, LabelWithTooltip } from 'components'
import { Icon as SuccessIcon } from 'images/status-icons/checkmark-green.svg'
import { formatCurrency } from 'utils'
import { FLASH_SUCCESS_WITH_USER_ACTION_TIMEOUT } from 'config/portal'
const propTypes = {
  values: PropTypes.shape({
    promoCode: PropTypes.string,
    promoApplied: PropTypes.bool,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  totalDiscount: PropTypes.number.isRequired,
  setFieldError: PropTypes.func,
  flashSuccessMessageHandler: PropTypes.func.isRequired,
  orderParams: PropTypes.object.isRequired,
  applyPromoCode: PropTypes.func.isRequired,
  normalizeResponse: PropTypes.func,
}

const defaultProps = {}

function PromoCode({
  values,
  setFieldValue,
  setFieldError,
  totalDiscount,
  flashSuccessMessageHandler,
  orderParams,
  applyPromoCode,
  normalizeResponse,
}) {
  const { promoCode, promoApplied } = values
  const onApply = async (e) => {
    e.preventDefault()
    try {
      const response = await applyPromoCode({ ...orderParams, promoCode })
      const { isPromoCodeValid, totalCost } = normalizeResponse(response)

      if (!isPromoCodeValid) {
        if (setFieldError)
          setFieldError('promoCode', 'Invalid promo code entry')
        return
      }
      setFieldValue('promoApplied', true)
      setFieldValue('discountedTotal', totalCost)
      flashSuccessMessageHandler(
        `Promo code applied!
                <br/>A discount has been applied to your total.
                `,
        {
          timeout: FLASH_SUCCESS_WITH_USER_ACTION_TIMEOUT,
        }
      )
    } catch (e) {
      if (setFieldError) setFieldError('promoCode', 'Invalid promo code entry')
    }
  }
  const onRemove = async (e) => {
    e.preventDefault()
    const response = await applyPromoCode({ ...orderParams })
    const { totalCost } = normalizeResponse(response)
    setFieldValue('discountedTotal', totalCost)
    setFieldValue('promoApplied', false)
    setFieldValue('promoCode', '')
  }

  return (
    <div className={`promo-code ${promoApplied ? 'is-applied' : ''}`}>
      <div className="promo-code__row">
        <div className="promo-code__input">
          {promoApplied && <SuccessIcon className="promo-code__icon" />}
          <Input
            label="Promo code"
            name="promoCode"
            placeholder="Enter code"
            disabled={promoApplied}
            required={false}
            labelComponent={LabelWithTooltip}
            tooltipContent="Enter a promo code received from Inspira"
            tooltipAriaLabel="Promo code information"
          />
        </div>
        {!promoApplied ? (
          <button
            className="button-text promo-apply"
            onClick={onApply}
            disabled={!promoCode}
          >
            Apply
          </button>
        ) : (
          <button className="button-text promo-remove" onClick={onRemove}>
            Remove
          </button>
        )}
      </div>
      {promoApplied && (
        <div className="promo-applied-message">
          Promo code: (-){formatCurrency(totalDiscount)}
        </div>
      )}
    </div>
  )
}
PromoCode.propTypes = propTypes
PromoCode.defaultProps = defaultProps

export default PromoCode
